module.exports = __webpack_public_path__ + "static/img/20017 (7).b73eb44.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20017 (7).webp
// module id = lPyt
// module chunks = 14